import { IconHelper } from '@liasincontrol/core-service';
import { IconSize } from '@liasincontrol/ui-basics';
import { Stack } from '@mui/material';
import { InnerProps, enhanceWithTooltip } from '../genericComponents/enhanceWithTooltip';

type Props = {
    displayValue: string;
} & InnerProps;

const Caption = ({ displayValue, ...rest }: Props) => {
    return (
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
            {IconHelper.getWorkFlowStatusIcon(displayValue, IconSize.small)}
            <div {...rest} className='dx-treelist-text-content' style={{whiteSpace: 'nowrap'}}>
                {displayValue}
            </div>
        </Stack>
    );
};

export const WfStepBadge = enhanceWithTooltip<Props>(Caption);
